.spotlightSearchWrapper {
    margin: 0 var(--mantine-spacing-sm);

    input {
        min-height: 64px;
    }
}

.spotlightSearchInput {
    font-size: var(--mantine-font-size-md);
    @media (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-lg);
    }
}

.spotlightActionsList {
    padding: var(--mantine-spacing-sm);
    max-height: 450px;
    overflow: hidden;
    > div {
        flex: 0;
        width: 100%;
    }
}

.spotlightActionsListInner {
    flex: 0;
    width: 100%;
}

.spotlightAction {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-xs);
    border-radius: var(--mantine-radius-md);
}

.spotlightAction:where([data-selected]) {
    background-color: var(--mantine-color-gneis-0);
    p {
        color: var(--mantine-color-dark-6);
    }
}

.skeletonGroup {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-xs);
}

.searchResultText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--mantine-color-gneis-9);
}

.titleText {
    font-size: var(--mantine-font-size-sm);
    @media (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-md);
    }
}

.asideText {
    font-size: var(--mantine-font-size-xs);
    @media (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-sm);
    }
}

.spotlightInner {
    padding-inline: var(--mantine-spacing-xs);

    @media (min-width: $mantine-breakpoint-sm) {
        padding-inline: var(--modal-inner-x-offset, var(--modal-x-offset));
    }
}
